<template>
  <div class="flex flex-col gap-[50px]">
    <div class="md:mx-[40px]">
      <p class="lg:text-[32px] md:text-[24px] text-[16px] font-[500] text-brand-orange mb-[10px] lg:mb-[9px]" style="line-height: normal">INFO</p>
      <p class="font-extrabold lg:text-[56px] md:text-[40px] text-[28px] font-gray-900" style="line-height: normal">Konference pro <span
        class="whitespace-nowrap">e-commerce</span> profesionály</p>
      <div class="py-[30px]">
        <p class="lg:text-[18px] text-[14px] font-gray-900">
          Shopcamp se už přes dekádu podílí na vzdělávání české e-commerce díky odborným přednáškám a praktickým
          workshopům. Umožňuje přátelské setkání e-shoperů a e-commerce odborníků na jednom místě.
        </p>
        <br>
        <p class="lg:text-[18px] text-[14px] font-gray-900">
          Shopcamp vytváříme na míru pro zástupce předních a etablovaných e-shopů, kteří chtějí držet krok s
          nejnovějšími trendy a inovacemi v e-commerce.
        </p>
        <br>
        <p class="lg:text-[18px] text-[14px] font-gray-900 lg:mb-[70px]">
          Po celý den probíhá program ve dvou přednáškových sálech, třech workshopových místnostech a nově účastníkům
          představíme také inspirativní mastermindy vedené zkušenými odborníky české e-commerce. Program doplňují
          partnerské stánky, kolo štěstí, skvělé občerstvení, uvolněná komunitní atmosféra a neformální networking.
        </p>
      </div>
    </div>
    <div class="flex flex-col justify-center">
      <Item
        v-for="(item, index) in items"
        :item-data="{...item, isOdd: index%2 !== 0}"
        class="md:mb-[70px] mb-[50px] mx-auto"
      ></Item>
    </div>
  </div>
</template>

<style scoped>

</style>

<script>

import Item from "./Item.vue";

export default {
  components: {Item},
  data() {
    return {
      items: [
        {
          videoId: 'MZEU19w169U',
          title: 'Špičkový obsah na Shopcampu',
          author: ' ',
          contentTitle: 'Odborný obsah',
          contentText: 'Špičky české e-commerce z řad úspěšných  e-shopů i odborníků sdílí s účastníky své  know-how a přináší jim inspiraci.',
          buttonText: 'Záznamy přednášek 2024',
        },
        {
          videoId: 'yJBmJAF960o',
          title: 'Shopcamp 2024',
          author: 'Aftermovie',
          contentTitle: 'Síla propojení',
          contentText: 'Jedinečná atmosféra a neformální networking, který usnadňuje navazování cenných obchodních kontaktů.'
        },
        {
          videoId: '1RXNyikuGOA',
          title: 'Shopcamp 2023',
          author: 'Aftermovie k 10. ročníku konference',
          contentTitle: 'Ověřená kvalita',
          contentText: 'Jsme tady 11 let a s průměrným hodnocením 9 z 10 každý ročník potvrzuje, že přináší účastníkům hodnotu, na kterou se mohou spolehnout.'
        }
      ]
    }
  }
}
</script>
